import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b72f012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sheet-personal-tel" }

import { ref, watch, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    placeholder: null,
    required: { type: Boolean },
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { placeholder?: string, required: boolean, modelValue: string | null }





const innerModelValue = ref('')

watch(
  () => props.modelValue,
  () => {
    innerModelValue.value = props.modelValue ?? ''
  },
  { immediate: true },
)

watch(innerModelValue, () => {
  emit('update:modelValue', innerModelValue.value)
})

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_input, {
      type: "tel",
      inputmode: "numeric",
      outlined: "",
      dense: "",
      pattern: "[\\d\\-]*",
      maxlength: "13",
      placeholder: __props.placeholder,
      modelValue: innerModelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerModelValue).value = $event))
    }, null, 8, ["placeholder", "modelValue"])
  ]))
}
}

})